import MultiCarousel from "@stadium/ui/src/components/multi-carousel";

import { useStoreContext } from "@components/store/provider";

import CategoryCard from "@components/shared/cards/category";

import { getMenuItemRoute } from "@constants/routes";

import styles from "./sub-category-taxon-carousel.module.scss";

const SubCategoryTaxonCarousel = ({ subCategories }) => {
  const { storeBasePath } = useStoreContext();

  const getCategoryCardProps = (item) => {
    return {
      id: item.id,
      name: item.name,
      image: item.attachment,
      slug: getMenuItemRoute({
        storeBasePath,
        category: item.code,
      }),
      className: "",
    };
  };
  if (subCategories.length === 0) return null;
  return (
    <div className={styles.categoryBannerContainer}>
      <h4 className={styles.storeHeading}>Shop Categories</h4>
      <div className={styles.subCategoryCarousel}>
        <MultiCarousel resolutionCountsMapping={{ desktop: 4, mobile: 2 }} partialVisible={true}>
          {subCategories.map((category) => (
            <CategoryCard {...getCategoryCardProps(category)} key={category.id} />
          ))}
        </MultiCarousel>
      </div>
    </div>
  );
};

export default SubCategoryTaxonCarousel;
